const axios = require("axios");

axios.defaults.baseURL = process.env.VUE_APP_BACK_URL;
var token = localStorage.getItem('jwt-secret-sauce');
axios.defaults.headers.common['Authorization'] = token;

export default {
  //
  // // create session/user
  //
  createUser(user) {
    console.log("createUser");
    return axios.post("/users", user);
  },
  addUser(user) {
    console.log("addUser");
    return axios.post("/add_user", user);
  },
  signInUser(user) {
    console.log("create a new session?");
    return axios.post("/users/sign_in", user);
  },
  deleteSession() {
    return axios.delete("/users/sign_out", {});
  },
  sendPasswordReset(data){
    return axios.post("/users/password", data);
  },
  setNewPassword(data){
    return axios.put("/users/password", data);
  },
  acceptInvite(data){
    return axios.put("/users/invitation", data);
  },

  //
  // // Projects
  //
  getProjects() {
    return axios.get("/projects");
  },
  getUsers() {
    return axios.get("/users");
  },
  getProject(id){
    return axios.get(`/projects/${id}`)
  },
  getProjectForGPR(id) {
    return axios.get(`/gpr_project/${id}`);
  },
  getReportForGPR(id) {
    return axios.get(`/gpr_report/${id}`);
  },
  getUserData(id) {
    return axios.get(`/users/${id}`);
  },
  getUserDataAndProjects(id) {
    return axios.get(`/user_and_projects/${id}`);
  },
  updateUserData(userData) {
    return axios.put(`/users/${userData.id}`, userData);
  },
  //
  // create ats request
  //
  submitAtsRequest(atsData){
    var ats = {
      ats_requests: atsData
    }
    return axios.post("/v1/ats_requests", ats);
  },
  //
  // // create companies
  //
  getCompanies() {
    return axios.get("/companies");
  },
  getPaymentIntent(data) {
    return axios.post('/payment_intent', data);
  },
  addNewCompany(id, company) {
    console.log(company);

    return axios.post("/companies", company);
  },
  addNewLicense(type) {
    return axios.post('/v1/licenses', type)
  },
  getCompanyData(id) {
    return axios.get(`/companies/${id}`);
  },
  updateUserData2(userId, userData) {
    return axios.put(`/update_gpr_access/${userId}`, userData);
  },
  getCompanyDataAdmin(id){
    return axios.get(`/admin_companies/${id}`)
  },
  updateCompanyData(companyId, companyData) {
    return axios.put(`/companies/${companyId}`, companyData);
  },
  inviteNewUser(newU) {
    // console.log(user);
    var u = {
      user: newU,
    };
    return axios.post("/invite_user", u);
  },
  inviteNewUserCompany(newU) {
    // console.log(user);
    var u = {
      user: newU,
    };
    return axios.post("/invite_user_company", u);
  },
  inviteNewUserByAdmin(newU) {
    return axios.post("/admin_invite_user", newU);
  },
  addNewUserToProject(data) {
    return axios.post("/invite_to_project", data);
  },
  uploadFileToProject(id, formData) {
    return axios.post(`/projects/${id}/attachments/`, formData);
  },
  createLogItem(projectId, formData) {
    return axios.post(`/projects/${projectId}/log_items`, formData);
  },
  getProjectFiles(id) {
    return axios.get(`/projects/${id}/attachments`);
  },
  getMaintenanceLogs(projectId) {
    return axios.get(`/projects/${projectId}/log_items`);
  },
  addNewLocation(formData) {
    return axios.post("/locations", formData);
  },
  addFileToCompany(companyId, formData) {
    return axios.post(`companies/${companyId}/attachments`, formData);
  },
  addFileToLocation(locationId, formData) {
    return axios.post(`locations/${locationId}/attachments`, formData);
  },
  deleteLocation(data) {
    return axios.delete(`/locations/${data.location_id}`, {data: data});
  },
  deleteUserFromProject(data) {
    return axios.delete("/delete_user_from_project", {data: data});
  },
  deleteUserFromCompany(data) {
    return axios.delete("/delete_user_from_company", { data: data });
  },
  advanceAction(data) {
    return axios.post("/advance_action", data);
  },
  updateLocation(data) {
    console.log(data)
    return axios.put(`/locations/${data.location.id}`, data)
  },
  createGPRLocation(data) {
    return axios.post("/GPRlocation", data);
  },
  submitGPR(data) {
    return axios.post("/gpr_reports", data);
  },
  submitSign(data) {
    return axios.post("/v1/add_signature", data);
  },
  updateGPR(data, id) {
    return axios.put(`/gpr_reports/${id}`, data);
  },
  submitQuiz(data){
    return axios.post("/quiz_finished", data)
  },
  addComment(data) {
    return axios.post("/comments", data);
  },
  deleteComment(id){
    return axios.delete(`/comments/${id}`);
  },
  deleteProject(id){
    return axios.delete(`/projects/${id}`);
  },
  getPDFLink(id){
    return axios.get(`/gpr_reports/${id}.pdf`);
  },
  sendJSAPDFEmail(data) {
    return axios.post('/send_jsa_pdf_email', data);
  },
  sendPDFEmail(data) {
    return axios.post('/send_pdf_email', data);
  },
  getProjectfromBarcode(data){
    console.log(data)
    return axios.get(`/fetch_barcode/${data}`);
  },
  addCompanyByAdmin(data) {
    return axios.post("/companies_admin", data);
  },
  createFacility(data) {
    return axios.post('/facilities', data);
  },
  deleteFacility(id) {
    return axios.delete(`/facilities/${id}`);
  },
  addEmployeesToNewCo(data){
    return axios.post("/coemployees_admin", data);
  },
  updateUserLevel(id, data){
    return axios.put(`/update_user_level/${id}`, data)
  },
  deleteUser(id){
    return axios.delete(`/users/${id}`);
  },
  resendInvite(data){
    return axios.post("/resendInvite", data);
  },
  deleteCompany(id) {
    return axios.delete(`/companies/${id}`);
  },
  deleteCompanyLogo(company_id, atachment_id) {
    return axios.delete(`/companies/${company_id}/attachments/${atachment_id}`);
  },
  createJsa(data) {
    return axios.post('/jsa_forms', data);
  },
  getProjectForJSA(id) {
    return axios.get(`/jsa_forms/${id}`);
  },
  getJSAPDFLink(id) {
    return axios.get(`/show_jsa_pdf/${id}.pdf`);
  },
  addFileToJSA(id, formData) {
    return axios.post(`jsa_forms/${id}/attachments`, formData);
  },
  addFileToJSALocation(id, formData) {
    return axios.post(`jsa_locations/${id}/attachments`, formData);
  },
  deleteJsaFile(jsa_form_id, atachment_id) {
    return axios.delete(
      `/jsa_forms/${jsa_form_id}/attachments/${atachment_id}`
    );
  },
  submitJSASign(data) {
    return axios.post('/add_jsa_signature', data);
  },
  createJSALocation(data) {
    return axios.post('/jsa_locations', data);
  },
  updateJSALocation(data) {
    return axios.put(`/jsa_locations/${data.location.id}`, data);
  },
  deleteJSALocation(data) {
    return axios.delete(`/jsa_locations/${data.location_id}`, { data: data });
  },
};
